import React from "react";
import "./PopupDeleteSession.scss";
import { toast } from "react-hot-toast";
import { deleteSessions } from "../../api/sessionService";
import { fetchDashboardData } from "../../redux/actions/dashboardActions";
import { useDispatch } from "react-redux";

const PopupDeleteSession = ({
  rowSelection,
  setRowSelection,
  onClose,
}) => {
  const dispatch = useDispatch();
  console.log(rowSelection)
  const sessionIds = Object.keys(rowSelection);

  const onDelete = async () => {
    let toastId = toast.loading("Deleting sessions...", {
      position: "top-center"
    });
    try {
      await deleteSessions(sessionIds);
      toast.success("Sessions deleted successfully!", {
        position: "top-center",
      });
      toast.remove(toastId);
      setRowSelection({});
      dispatch(fetchDashboardData());
      onClose();
    } catch (error) {
      toast.remove(toastId);
      toast.error("Failed to delete sessions. Please try again.", {
        position: "top-center",
      });
      onClose();
    }
  };

  return (
    <div className="popup delete-sesion">
      <div className="popup-content delete-session">
        <div className="tit-popup">
          <h2>Delete Session</h2>
        </div>
        <div>
          <div className="pregunta">
            <p>Are you sure you want to delete the session?</p>
          </div>
        </div>
        <div className="cont-btn">
          <button className="btn btn-red" onClick={onDelete}>
            Delete
          </button>
          <button className="btn" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupDeleteSession;
